/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  return format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href:url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param  str {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) {
      s++
    } else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
      .replace(/\+/g, ' ') +
    '"}'
  )
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? []:{}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} ele
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} ele
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} ele
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

// 下载文件
export function downLoadFile(href, fileName) {
  if (!fileName || !href) return
  //src是图片路径
  var eleLink = document.createElement('a')
  eleLink.download = fileName
  eleLink.style.display = 'none'
  //字符内容转变成blob地址
  eleLink.href = href
  //触发点击
  document.body.appendChild(eleLink)
  eleLink.click()
  //然后移除
  document.body.removeChild(eleLink)
}

//
export async function printByBrowser(val) {
  // debugger
  let printStyle
  if (val === 1){
    printStyle = `
*{box-sizing:border-box;font-family: "Microsoft YaHei";}
.table_box {
  width: 93%;
  border-collapse: collapse;
  table-layout: fixed;
  border-top: 0;

}

.tr-white {
  background-color: white;
}

.bottom-box {
  margin-top: 20px;
  margin-left: 60px;
  color: #111;
}

.bottom-box1 {
  width: 390px;
  display: inline-block;
}

.bottom-box2 {
  width: 390px;
  display: inline-block;
}

.bottom-box3 {
  color: #666666;
}

.title {
  width: 93%;
  text-align: center;
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: bolder;
}

  .list_txt {
    display: inline-block;
    padding-left: 20px;
  }

  tr, td, th {
    text-align: center;
    height: 30px;
    line-height: 55px;
    font-size: 16px;
    color: #333;
    word-wrap: break-word;
  }

  tr.table_header {
    height: auto;
    line-height: initial;
  }

  th {
    background: #fff;
  }

  .table_name {
    background: rgba(144, 147, 153, 0.3);
    text-align: center;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    color: #333;
    word-wrap: break-word;
  }

  .table_label {
    color: #666;
  }
  .bottom-box{
  margin-top: 20px;
  margin-left: 60px;
  color: #111;
  }
  .bottom-box1 {
  width: 45%;
  display: inline-block;
}

.bottom-box2 {
  width: 40%;
  display: inline-block;
}

  `
  } else if(val == 2) {
    printStyle = `
*{box-sizing:border-box;font-family: "Microsoft YaHei";}
#barcode{
  width: 68mm;
}
.print_box {
  padding-left: 30px;
  padding-right: 30px;
}
p,span{
    font-size:12px;
    line-height:15px;
}
.print_box .print_title {
    font-size: 14px;
    font-weight: bold;
    border-left: 1px solid black;
    padding-left: 10px;
    margin: 2mm 0;
}

.print_box .post_info {
    background-color: gray;
    border: 1px solid black;
    padding: 0 20px;
}

.print_box .post_info p {
    margin: 0;
    line-height: px;
    font-size: 12px;
}

.print_box .post_info p .post_time {
    padding-left: 4mm;
}

.print_box .medicine_table {
    width: 186mm;
    border-width: thin;
    border-style: solid;
    border-collapse: collapse; /*关键代码*/
}

.print_box .medicine_table .tr, .print_box .medicine_table .td {
    text-align: left;
    height: 20px;
    line-height: 15px;
    font-size: 12px;
    color: black;
    word-wrap: break-word;
    outline: none;
}

.print_box .medicine_table .title {
    background-color: white;
    color: black;
}

.print_box .medicine_table .tr.center, .print_box .medicine_table .td.center {
    text-align: center;
    padding:0;
}

.print_box .medicine_table .td {
    padding-left: 10px;
}
.font-bolder {
  font-weight: bolder;
}
.post-info{
  width: 65px;
  display: inline-block;
  text-align: right;
}

.print_box .print_title_stock {
  font-size: 16px;
  font-weight: bold;
  padding-left: 10px;
  text-align: center;
}
.print_title_stock_page{
  margin-left: 150px;
  font-weight: normal;
}
.print-stock-tit{
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  margin-top: 10px;
  margin-bottom: 10px;

}


`
  }else if(val == 3){
    printStyle = `
 body{
 width:100%;
 padding: 0 4mm;
 max-width: 130mm;
 }
.print_cf {
  width: 100%;
  overflow: hidden;
 }
p, strong, span {
  font-size: 16px;
  margin:0;
  padding:0;
  border:0;
}

.title {
  line-height: 26px;
  text-align: center;
  width:100%;

}
.title1 {
  line-height: 26px;
  text-align: center;
}
.print_info {
  width: 100%;
}
.top-cell{
  min-height: 26px;
  line-height: 26px;
  font-size: 14px;
  vertical-align: top;
}
.top-cell1{
  width: 200px;
  display: inline-block;
  font-size: 14px;
}
.top-cell2{
  width: 100px;
}
.top-cell22{
  width: 140px;
}
.top-cell23{
  width: 190px;
}
.top-cell4{
  width: 150px;
}
.top-cell3{
  width: 290px;
  font-size: 14px;
}
.top-cell5{
  width: 160px;
}
.top-cell5-1{
  width: 140px;
}
.top-cell5-5{
  width: 100px;
}
.top-cell7{
  width: 420px;
}
.top-cell71{
  margin-top: 10px;
}
.top-cell12{
  min-width: 250px;
  min-height:32px;
 }
.top-cell8{
  width: 520px;
}
.top-cell9{
  width: 224px;
}
.top-cell10{
  min-width: 280px;
  display: inline-block;
}
.top-cell13{
  font-size:16px;
  width:140px;
}
.top-cell-doctor{

padding-left: 160px;
}
.top-cell-doctor1{

padding-left: 580px;
}
.top-cells{
  padding: 4px 0;
}
.top-cell6{
  min-width: 450px;
  font-size: 14px;
  display: inline-block;
}
.hr-line{
  margin: 4px 0;
}
.top-cell-main{
  margin: 6px 0;
}
.print-footer{
  margin-top: 20px;
}
.print-footer-zhu{
  font-size: 20px;
  color: #333;
}
.print-footer1{
  line-height: 30px;
}
.print-footer2{
  padding-left: 50px;
  line-height: 30px;
}
.rp_title {
  padding-left: 8px;
  border-left: 2px solid black;
}

.medicine_box{
  width:100%;
  padding-bottom:2mm;
  overflow:hidden;
}
.medicine_list {
  // display: block;
  width: 240px;
  float: left;
  padding-bottom:4mm;
}

.medicine_list .medicine_first{
    // display: table-cell;
    vertical-align: middle;
    max-width: 64px;
    height: 40px;
    float:left;
}

.medicine_list .medicine_name {
  // display: table-cell;
  vertical-align: middle;
  max-width: 64px;
  height: 40px;
}

.medicine_list .medicine_other {
  display: block;
  width: 50px;
  line-height: 60px;
  margin-left: 60px;
  float:left;
}
.medicine_other .medicine_nozs{
    margin-top: -20px;
}
.medicine_box .medicine_other span {
  display: block;
  height: 20px;
  line-height: 20px;
}
.top-cell-remark{
  margin-top: 10px;
}
.doctor_name{
  display:block;
  text-align:right;
  padding-right: 4mm;
  font-size:16px;
  line-height:40px;
}

.print_footer{
  width:100%;
  padding-bottom:60px;
}

.print_footer table {
  table-layout: fixed;
  width:100%;
  text-overflow:ellipsis;
  border-collapse:collapse;
}

.line {
  display: inline-block;
  width: 32mm;
  border-bottom: 1px solid black;
}
.img-box{
display: flex;
justify-content: left;
align-items: center;
padding-left: 1mm;
margin-top: 2mm;
}
.img-audit{
width: 18mm;
height: 8mm;
}
`

  } else {
    printStyle = `
*{box-sizing:border-box;font-family: "Microsoft YaHei";}
#barcode{
  width: 68mm;
}
.print_box {
    width:68mm;
    margin:0 auto;
}
p,span{
    font-size:12px;
    line-height:15px;
}
.print_box .print_title {
    font-size: 14px;
    font-weight: bold;
    border-left: 1px solid black;
    padding-left: 10px;
    margin: 2mm 0;
}

.print_box .post_info {
    background-color: gray;
    border: 1px solid black;
    padding: 0 20px;
}

.print_box .post_info p {
    margin: 0;
    line-height: px;
    font-size: 12px;
}

.print_box .post_info p .post_time {
    padding-left: 4mm;
}

.print_box .medicine_table {
    width: 68mm;
    border-width: thin;
    border-style: solid;
    border-collapse: collapse; /*关键代码*/
}

.print_box .medicine_table .tr, .print_box .medicine_table .td {
    text-align: left;
    height: 20px;
    line-height: 15px;
    font-size: 12px;
    color: black;
    word-wrap: break-word;
    outline: none;
}

.print_box .medicine_table .title {
    background-color: white;
    color: black;
}

.print_box .medicine_table .tr.center, .print_box .medicine_table .td.center {
    text-align: center;
    padding:0;
}

.print_box .medicine_table .td {
    padding-left: 10px;
}
.font-bolder {
  font-weight: bolder;
}
.post-info{
  width: 65px;
  display: inline-block;
  text-align: right;
}`

  }
  const LodopFuncs = require('./LodopFuncs')
  const htmlStr = document.getElementById('print-container').innerHTML
  const LODOP = await LodopFuncs.getLodop()
  if (!LODOP) return
  LODOP.PRINT_INITA(1,1,770,660,"测试预览功能");
  LODOP.ADD_PRINT_HTM(30,val?5:-8,"100%","90%",`<style>${printStyle}</style><body>${htmlStr}</body>`);
  LODOP.PREVIEW();

  // LODOP.PRINT_INIT('经方云-药房管理')
  // LODOP.ADD_PRINT_HTM(2, 5, 80, 2000, `<style>${printStyle}</style><body>${htmlStr}</body>`)
  // LODOP.SET_PRINT_MODE('AUTO_CLOSE_PREWINDOW', 1)//打印后自动关闭预览窗口
  // LODOP.PREVIEW(0, 0, '100%', '100%')

//   const printContentHtml = document.getElementById('print-container').innerHTML
//   const iframe = document.createElement('iframe')
//   iframe.setAttribute('style', 'position:absolute;left:500px;top:500px;margin:0;')
//   document.body.appendChild(iframe)
//   iframe.contentDocument.write(`<style>@page {margin: 0;} ${printStyle}</style><link rel="stylesheet" href="http://unpkg.com/element-ui/lib/theme-chalk/index.css">` + printContentHtml)
//   iframe.contentDocument.close()
//   iframe.contentWindow.print()
//   document.body.removeChild(iframe)
}
